
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import {getFormState} from '../../../helpers/form';
import dayjs from 'dayjs';
const API_HOST = CONFIG.modules['accounts'].host




export const List = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const [active, setActive] = useState('Leave Requests')
    const [data, setData] = useState(users||[])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('new')
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false)
    const [filter, setFilter] = useState({
        from: dayjs('01-01-2023'),
        to: dayjs(),
    })

    const fetchLeaves = () => {
        axios.get(API_HOST + `/leave?from=${encodeURIComponent(dayjs(filter.from).format('YYYY-MM-DD'))}&to=${encodeURIComponent(dayjs(filter.to).format('YYYY-MM-DD'))}`).then((resp) => {
            if (resp.data && resp.data.success) {
                setData(resp.data.data.map((u)=> {
                    u.name = u.user.name
                    return u
                }))
            }
        }).catch((e) => {
            console.log(e)
        })
    }


    useEffect(() => {
         fetchLeaves()
    }, [active])

    useEffect(() => {
        fetchLeaves()
   }, [filter])





    const handleEdit = (id,status) => {
       
        axios.put(API_HOST + `/leave/${data[id]._id}`, {
            status
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                data[id] = resp.data.data
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }


    return (
        <>
            {/* <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} /> */}
            <ToolBar name={'Leaves'} buttons={[
            ]} filters={[
              
                {
                    field: {
                        name: 'from',
                        type: 'date',
                        label: 'From',
                    },
                    onChange: (name, value) => {
                        filter[name] = value
                        setFilter({...filter})
                    },
                    state: filter

                },
                {
                    field: {
                        name: 'to',
                        type: 'date',
                        label: 'To',
                    },
                    onChange: (name, value) => {
                        filter[name] = value
                        setFilter({...filter})
                    },
                    state: filter

                }
            ]}
        />
            <Box sx={{ mt: 2 }}>
                <Grid data={data} columns={[
                     {
                        id: 'createdAt', label: 'Date', minWidth: 60, format: (data, row) => {
                            return data ? dayjs(data).format('DD-MM-YYYY HH:mm:ss') : ''
                        }
                    },
                     { id: 'user', label: 'User', minWidth: 170 ,format: (data, row) => {
                        return data?data.name || '':''
                    } },
                    { id: 'leaveType', label: 'Type ', minWidth: 120, format: (data, row) => {
                        return data?data=='full'?'Full day':data=='half'?'Half day':'Shift swapping':'Full day'
                    } },
                //    { id: 'type', label: 'Type ', minWidth: 170 },
                //    { id: 'description', label: 'Description', minWidth: 170 },
                   { id: 'approved', label: 'Status', minWidth: 170 },
                   { id: 'from', label: 'From', minWidth: 170, format: (data, row) => {
                    return data ? dayjs(data).format('DD-MM-YYYY') : ''
                } },
                   { id: 'to', label: 'To', minWidth: 170, format: (data, row) => {
                    return data ? dayjs(data).format('DD-MM-YYYY') : ''
                } },
                ]}
               
                
                    ></Grid>
            </Box>
            {/* <Modal open={open}
                handleClose={() => { setOpen(false) }}
                head={`${action == 'new' ? 'Add' : 'Edit'} ${active}`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpen(false)
                        }
                    },
                    {
                        name: action == 'new' ? 'Create' : 'Save',
                        onClick: () => {
                            switch (action) {
                                case 'new':
                                    handleSubmit()
                                    break;
                                case 'edit':
                                    handleEdit()
                                    break;
                                default: break;
                            }
                        }
                    }
                ]}

            >
                 {
                    action == 'edit' &&
                    <Typography variant='p' color="grey">{
                        'ID: ' + saved._id
                    }</Typography>
                }
                {
                    Array.isArray(fields) &&
                    <FormA fields={fields}
                        data={{ roles, Designations, Districts, Languages, Departments, users }}
                        onChange={(name, value, multiple) => {
                            formData[name] = value
                            setFormData({ ...formData })
                        }}
                        state={formData||{}}
                    />
                }
               

            </Modal>

            <Modal open={openConfirm}
                handleClose={() => { setOpen(false) }}
                head={`${'Delete'} ${active}`}
                desc={`Please confirm to delete the following ${active}?`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpenConfirm(false)
                        }
                    },
                    {
                        name: 'Delete',
                        onClick: () => {
                            handleDelete()
                        }
                    }
                ]}

            >
                {
                    saved &&
                    <Box>
                        <Typography variant='p' color="grey">{'ID: ' + saved._id}</Typography><br></br>
                        <Typography variant='p' color="grey">{'Name: ' + saved.name}</Typography>
                    </Box>
                }

            </Modal> */}
        </>
    )
}